module.exports = __webpack_public_path__ + "img/56.28386c65.jpg";